import CIMSFormItem from 'components/CIMSFormItem'
import ReportSelect from 'components/CIMSSelect/common/ReportSelect'
import AdvancedOptions from './AdvancedOptions'
import {
  CreateBatchReportJobInput,
  useCreateBatchReportJobMutation,
} from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import GenericRequest from '../../GenericRequest'
import { errorHandler } from 'hooks/errorHandler'
import { useProjectContext } from 'context/ProjectContext'
import { notificationHandler } from 'hooks/notificationHandler'
import { dateFormatter } from 'utils/dateFormatter'

const Request: React.FC = () => {
  const { projectId } = useProjectContext()
  const [create, { loading: creating }] = useCreateBatchReportJobMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({ createBatchReportJob: { job } }) => {
      notificationHandler({
        alternateType: 'success',
        title: `Batch Report Request successfully made at ${dateFormatter.shortDatetime(
          job.createdDate
        )}`,
        details: `An email will be sent to ${job.createdUser} with more details.`,
      })
    },
  })
  return (
    <GenericRequest
      estimatesAreCalculatedBy="summing each selected Report type's global median time to generate by the total number of records returned with the configured Advanced Options. It does not include the time the request may need to wait in the Queue"
      request={{
        name: 'Batch Report Request',
        type: 'reports',
        maxMilliseconds: false,
      }}
      reduceEstimatesBy="adjusting Advanced Options to narrow results"
      errorMessagesInclude="the Report type associated with the error and the database ID used to attempt to generate the Report. Use this ID and Report type to generate a Single Report if desired"
      loading={creating}
      onRequest={({ reportIds, dateRange, payItemIds }) => {
        if (!reportIds) return errorHandler('reportIds is not defined')
        const [from, to] = dateRange ?? []
        const input: CreateBatchReportJobInput = {
          projectId,
          reportIds,
          payItemIds: payItemIds?.length ? payItemIds : undefined,
          // Using bang since if dateRange is truthy, then `from` and `to` must be present
          dateRange: dateRange
            ? {
                from: from!.startOf('day').toISOString(),
                to: to!.endOf('day').toISOString(),
              }
            : undefined,
        }
        create({ variables: { input } })
      }}
    >
      <CIMSFormItem
        name="reportIds"
        label="Report(s)"
        requiredMessage="Please select one or more reports"
      >
        <ReportSelect mode="multiple" />
      </CIMSFormItem>
      <AdvancedOptions />
    </GenericRequest>
  )
}

export default Request
